<template>
  <div class="todo-list-form">
    <div class="todo-list-form-header">
      <div class="todo-list-form-header-title">
        <span>{{ '待办事项' }}</span>
      </div>
      <!-- <div v-if="!disabled">
        <el-button
          type="primary"
          size="mini"
          icon="el-icon-plus"
          plain
          @click="add()"
        >
          {{ '添加待办' }}
        </el-button>
      </div> -->
    </div>
    <el-form
      ref="form"
      size="small"
      class="todo-list-form-item"
      v-for="(item, index) in list"
      :key="index"
      :model="item"
      :rules="rules"
    >
      <el-row :gutter="10">
        <el-col :span="24" style="margin-bottom: 14px;">
          <div class="d-flex flex-row align-items-center">
            <div class="mr-2">
              <div class="todo-list-form-circle"></div>
            </div>
            <div
              class="flex-grow-1 d-flex justify-content-between align-items-center"
            >
              <div class="d-flex">
                <el-form-item
                  class="mr-2"
                  prop="todoTypeKey"
                  style="margin-bottom: 0 !important;"
                >
                  <dict-select
                    v-if="!disabled"
                    v-model="item.todoTypeKey"
                    url="/digitalCenter/tsk/todo/type/select"
                    :placeholder="'请选择事项类型'"
                    filterable
                    clearable
                    style="width: 100%"
                    @change="valueChange"
                  />
                  <el-input
                    v-else
                    v-model="item.todoName"
                    readonly
                    style="width: 100%"
                  />
                </el-form-item>
                <el-form-item prop="tskBy" style="margin-bottom: 0 !important;">
                  <dict-select
                    v-if="!disabled"
                    v-model="item.tskBy"
                    :selectedLabel.sync="item.tskByName"
                    url="/master/common/dict/baseUserSelect"
                    :placeholder="'请选择经办人'"
                    filterable
                    clearable
                    style="width: 100%"
                    @change="valueChange"
                  />
                  <el-input
                    v-else
                    v-model="item.tskByName"
                    readonly
                    style="width: 100%"
                  />
                </el-form-item>
              </div>
              <i
                v-if="!disabled"
                class="el-icon-delete tool-btn text-danger"
                style="font-size: 24px;"
                @click="del(index)"
              />
            </div>
          </div>
        </el-col>
        <el-col :span="24">
          <div class="d-flex flex-row align-items-center">
            <div class="mr-2" style="width: 24px;"></div>
            <div class="flex-grow-1">
              <el-form-item
                prop="tskDescription"
                style="margin-bottom: 0 !important;"
              >
                <TopicsEditor
                  :class="{ readonly: disabled }"
                  v-model="item.tskDescription"
                  @change="valueChange"
                  :disabled="disabled"
                />
              </el-form-item>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-form>

    <div class="empty-block" v-if="isEmpty">
      <div style="text-align: center">
        <img src="/image/static/img/nodata.png" />
        <p class="no-data mt-2">
          {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import validate from '@/libs/util.validate'
import TopicsEditor from '../topics-editor'
const init = { todoTypeKey: '', tskDescription: '' }
export default {
  components: { TopicsEditor },
  props: {
    tskInfoCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      list: [],
      rules: {
        todoTypeKey: [
          { trigger: 'change', required: true, message: '请选择事项类型' },
        ],
        tskBy: [{ trigger: 'change', required: true, message: '请选择经办人' }],
        tskDescription: [
          { trigger: 'blur', required: true, message: '请输入事项描述' },
        ],
      },
    }
  },
  computed: {
    isEmpty() {
      return !this.list?.length
    },
  },
  watch: {
    tskInfoCode() {
      this.getData()
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.tskInfoCode) return
      const res = await this.$api
        .expoTskInfoSelectionTodoListApi({ tskInfoCode: this.tskInfoCode })
        .catch(() => null)
      this.list = res?.body?.data || []
    },
    add() {
      this.list.push({ ...init })
      this.valueChange()
    },
    del(index) {
      this.list.splice(index, 1)
      this.valueChange()
    },
    valueChange() {
      this.$emit('valueChange')
    },
    async validate() {
      const form = this.$refs.form
      if (!form?.length) return true
      return await validate.formValidate(form)
    },
    get() {
      return this.list
    },
  },
}
</script>

<style lang="scss" scoped>
.todo-list-form {
  .todo-list-form-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .todo-list-form-header-title {
      font-size: 18px;
      color: #101010;
      display: flex;
      align-items: center;
      // i {
      //   // font-size: 24px;
      // }
    }
  }
  .todo-list-form-item {
    margin-top: 18px;
  }
  .todo-list-form-circle {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: 1px solid #aeaeae;
  }
}
.empty-block {
  img {
    height: 150px;
  }
  .no-data {
    color: #606266;
    font-size: 13px;
  }
}
::v-deep {
  .ql-container,
  .container {
    min-height: 150px;
    max-height: 150px;
  }
  .el-form-item__content {
    color: #606266;
    font-size: 12px !important;
    .quill_editor-wrapper.readonly {
      .ql-editor.ql-blank {
        border: 1px solid #dcdfe6;
        .container {
          padding: 0;
        }
      }
    }
  }
  input[readonly] {
    border: 1px solid #dcdfe6 !important;
  }
}
</style>
